import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ModuleTile } from "@/components/ui";
import { findNav } from "@/navigation";

// Every menu entry whose screen isn't built yet lands here, so the whole menu
// is navigable from day one. Built screens have their own static route, which
// TanStack Router ranks above this dynamic one.
export const Route = createFileRoute("/_app/$module/$page")({
  loader: ({ params }) => {
    const nav = findNav(params.module, params.page);
    if (!nav) throw notFound();
    return nav;
  },
  component: PlaceholderPage,
});

function PlaceholderPage() {
  const { t } = useTranslation();
  const { module: m, item } = Route.useLoaderData();
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <nav aria-label="Breadcrumb" className="text-[13px] text-ink-muted">
          {t(m.labelKey)}
        </nav>
        <h1 className="text-[28px] font-semibold leading-9 tracking-[-0.02em]">{t(item.labelKey)}</h1>
      </div>
      <div className="flex min-h-[360px] flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-border bg-surface px-6 py-16 text-center">
        <ModuleTile icon={m.icon} tone={m.tone} size="lg" />
        <h2 className="text-lg font-semibold">{t("placeholder.title", { page: t(item.labelKey) })}</h2>
        <p className="max-w-md text-ink-muted">{t("placeholder.body", { module: t(m.labelKey) })}</p>
        <Link
          to="/"
          className="mt-2 inline-flex h-10 items-center gap-2 rounded-xl border border-border bg-surface px-4 font-medium text-ink hover:bg-surface-hover"
        >
          <ArrowLeft size={16} aria-hidden="true" />
          {t("placeholder.backHome")}
        </Link>
      </div>
    </div>
  );
}
